import { Icon, IconProps } from './Icon';

export type PerspectiveProps = IconProps;

export const Perspective = (props: PerspectiveProps) => (
  <Icon width="16px" height="16px" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <path d="M10.667 3.333v9.334m-4-10v10.666M2 8h12M2 3.993v8.014c0 .91 0 1.364.188 1.68.164.276.423.483.728.584.349.115.792.016 1.68-.181l7.733-1.719c.596-.132.895-.199 1.117-.359.196-.141.35-.333.446-.555.108-.252.108-.558.108-1.168V5.71c0-.61 0-.916-.108-1.168a1.333 1.333 0 0 0-.446-.555c-.222-.16-.52-.227-1.117-.36L4.596 1.91c-.888-.197-1.331-.296-1.68-.18-.305.1-.564.307-.728.584C2 2.629 2 3.084 2 3.993Z" stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round"/>
  </Icon>
)
